import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const LinkBrokenIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="linkBroken" ref={ref} {...props}>
      <path d="M6.58,21.79a4.37,4.37,0,0,1-3.09-7.46L7,10.88a.74.74,0,0,1,1.06,0,.75.75,0,0,1,0,1.06L4.55,15.4a2.86,2.86,0,1,0,4.05,4l2.87-2.86a.74.74,0,0,1,1.06,0,.75.75,0,0,1,0,1.06L9.67,20.51A4.38,4.38,0,0,1,6.58,21.79Zm10.7-8.9,3.23-3.22a4.37,4.37,0,1,0-6.18-6.18L11.47,6.36a.74.74,0,0,0,0,1.06.75.75,0,0,0,1.06,0l2.86-2.87A2.87,2.87,0,1,1,19.45,8.6l-3.23,3.23a.75.75,0,0,0,0,1.06.74.74,0,0,0,.53.22A.73.73,0,0,0,17.28,12.89ZM7.79,9.1a.75.75,0,0,0-.37-1L4.31,6.68A.75.75,0,0,0,3.69,8L6.8,9.47a.67.67,0,0,0,.31.07A.75.75,0,0,0,7.79,9.1ZM9.11,7.57a.74.74,0,0,0,.37-1L8.16,3.69a.75.75,0,1,0-1.36.62L8.12,7.2a.74.74,0,0,0,.68.44A.7.7,0,0,0,9.11,7.57ZM20.7,17a.74.74,0,0,0-.37-1l-3.11-1.43a.75.75,0,0,0-.62,1.36l3.11,1.43a.67.67,0,0,0,.31.07A.75.75,0,0,0,20.7,17Zm-3.85,3.73a.75.75,0,0,0,.37-1L15.9,16.81a.75.75,0,0,0-1.36.62l1.31,2.89a.75.75,0,0,0,.69.44A.7.7,0,0,0,16.85,20.69Z" />
    </Icon>
  ),
) as IconWithRender;

LinkBrokenIcon.displayName = 'LinkBrokenIcon';
LinkBrokenIcon.renderIcon = (props) => <LinkBrokenIcon {...props} />;
export default LinkBrokenIcon;
